module.exports = __webpack_public_path__ + "static/media/MCT-Slider-mobile-1.29c99033.jpg";